import { SVGProps } from 'react';

export const PlayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='11'
    height='12'
    viewBox='0 0 11 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M0.5 1.76865C0.5 1.19819 1.1116 0.836573 1.61144 1.11148L9.30516 5.34303C9.82324 5.62798 9.82324 6.37241 9.30516 6.65736L1.61144 10.8889C1.1116 11.1638 0.5 10.8022 0.5 10.2317V1.76865Z'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
